<template>
  <el-dialog :visible.sync="dialogVisible" :title="title" width="500">
    <span>{{ description }}</span>
    <template #footer>
      <div class="dialog-footer">
        <el-button class="button-secondary" @click="dialogVisible = false">{{
          cancelButtonText
        }}</el-button>
        <el-button class="button-primary" @click="handleConfirm">
          {{ confirmButtonText }}
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>
<script>
  export default {
    name: 'DialogConfirm',
    data() {
      return {
        dialogVisible: false
      }
    },
    props: {
      title: {
        type: String,
        default: ''
      },
      description: {
        type: String,
        default: ''
      },
      confirmButtonText: {
        type: String,
        default: 'Crear'
      },
      cancelButtonText: {
        type: String,
        default: 'Cancelar'
      },
      callback: {
        type: Function,
        default: () => {}
      }
    },
    methods: {
      open() {
        this.dialogVisible = true
      },
      handleConfirm() {
        this.callback()
        this.dialogVisible = false
      }
    }
  }
</script>
<style lang="scss" scoped>
  .dialog-footer {
    display: flex;
    justify-content: flex-end;
  }
</style>
